import React from 'react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
  className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  text = 'Đang tải...',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  }

  const textSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  }

  return (
    <div className={`flex flex-col items-center justify-center min-h-[200px] ${className}`}>
      <div className="relative">
        {/* Spinner chính */}
        <div className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-gray-200 border-t-primary-600`} />
        
        {/* Spinner phụ (hiệu ứng đẹp) */}
        <div className={`${sizeClasses[size]} absolute top-0 left-0 animate-spin rounded-full border-4 border-transparent border-t-blue-400 animate-pulse`} 
             style={{ animationDelay: '0.1s' }} />
        
        {/* Spinner phụ thứ 2 */}
        <div className={`${sizeClasses[size]} absolute top-0 left-0 animate-spin rounded-full border-4 border-transparent border-t-indigo-500 animate-pulse`} 
             style={{ animationDelay: '0.2s' }} />
      </div>
      
      {text && (
        <p className={`mt-4 text-gray-600 font-medium ${textSizes[size]} animate-pulse`}>
          {text}
        </p>
      )}
      
      {/* Dots animation */}
      <div className="flex space-x-1 mt-2">
        <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  )
}

export default LoadingSpinner
